import { useMemo } from 'react'
import PropTypes from 'prop-types'

import isSafariIOS from 'common/utils/isSafariIOS'
import classNames from './styles.module.scss'


MasonryVideoItem.propTypes = {
  videoId: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
}

export default function MasonryVideoItem({
  videoId,
  videoTitle,
}) {
  const src = useMemo(() => {
    const base = `https://www.youtube-nocookie.com/embed/${videoId}?`
    const params = isSafariIOS()
      ? 'playsinline=0&rel=0'
      : 'playsinline=1&rel=0&loop=1&playlist=' + videoId
    return base + params
  }, [videoId])

  return (
    <div className={classNames.item}>
      <div className={classNames.videoContainer}>
        <iframe
          src={src}
          title={videoTitle}
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </div>
    </div>
  )
}
